export default "<p>redirect-policy works!</p>\r\n";